module.exports = __webpack_public_path__ + "static/media/icon_notificacion_small.5e0fa8ee.svg";